import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { SettingsProvider } from "./context/SettingsContext";
import ProtectedRoute from "./components/ProtectedRoute";

// Public Pages
import HomePage from "./pages/HomePage";
import CarDetailPage from "./pages/CarDetailPage";

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminCars from "./pages/admin/AdminCars";
import AdminCarForm from "./pages/admin/AdminCarForm";
import AdminLeads from "./pages/admin/AdminLeads";
import AdminFinance from "./pages/admin/AdminFinance";
import AdminExpenses from "./pages/admin/AdminExpenses";
import AdminVehicleFinance from "./pages/admin/AdminVehicleFinance";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminMonthlyReport from "./pages/admin/AdminMonthlyReport";
import AdminAnnualReport from "./pages/admin/AdminAnnualReport";

function App() {
  return (
    <HelmetProvider>
    <SettingsProvider>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/viatura/:id" element={<CarDetailPage />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/viaturas" element={<ProtectedRoute><AdminCars /></ProtectedRoute>} />
          <Route path="/admin/viaturas/nova" element={<ProtectedRoute><AdminCarForm /></ProtectedRoute>} />
          <Route path="/admin/viaturas/:id" element={<ProtectedRoute><AdminCarForm /></ProtectedRoute>} />
          <Route path="/admin/leads" element={<ProtectedRoute><AdminLeads /></ProtectedRoute>} />
            <Route path="/admin/financas" element={<ProtectedRoute><AdminFinance /></ProtectedRoute>} />
            <Route path="/admin/financas/despesas" element={<ProtectedRoute><AdminExpenses /></ProtectedRoute>} />
            <Route path="/admin/financas/viatura/:id" element={<ProtectedRoute><AdminVehicleFinance /></ProtectedRoute>} />
            <Route path="/admin/financas/relatorio" element={<ProtectedRoute><AdminMonthlyReport /></ProtectedRoute>} />
            <Route path="/admin/financas/relatorio-anual" element={<ProtectedRoute><AdminAnnualReport /></ProtectedRoute>} />
            <Route path="/admin/definicoes" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
    </SettingsProvider>
    </HelmetProvider>
  );
}

export default App;
